// ============================================================================
// This file is MSN 2026 PROJECT SPECIFIC
// ============================================================================

// Registration member types
const initMemberTypes = () => {
  const countrySelect = document.getElementById('user_country')
  const memberTypeSelect = document.getElementById('user_member_type_id')

  if (!countrySelect || !memberTypeSelect) return

  const memberTypes = JSON.parse(memberTypeSelect.dataset.memberTypes || '{}')

  const updateMemberTypeOptions = () => {
    const selectedCountryCode = countrySelect.value
    const desiredValue = memberTypeSelect.dataset.selectedValue || memberTypeSelect.value

    memberTypeSelect.innerHTML = '<option value="">Please Select</option>'

    if (!selectedCountryCode) {
      memberTypeSelect.disabled = true
      memberTypeSelect.value = ''
      memberTypeSelect.dataset.selectedValue = ''
      memberTypeSelect.dispatchEvent(new Event('change'))
      return
    }

    Object.entries(memberTypes).forEach(([memberTypeName, memberTypeData]) => {
      const { id, country_rule, countries = [] } = memberTypeData
      let shouldShow = false

      switch (country_rule) {
        case 'all_countries':
          shouldShow = true
          break
        case 'specific_countries':
          shouldShow = countries.includes(selectedCountryCode)
          break
        case 'exclude_countries':
          shouldShow = !countries.includes(selectedCountryCode)
          break
      }

      if (!shouldShow) return

      const option = document.createElement('option')
      option.value = id
      option.textContent = memberTypeName
      memberTypeSelect.appendChild(option)
    })

    if (
      Array.from(memberTypeSelect.options).some((option) => option.value === String(desiredValue))
    ) {
      memberTypeSelect.value = desiredValue
    } else {
      memberTypeSelect.value = ''
    }

    memberTypeSelect.disabled = memberTypeSelect.options.length <= 1
    memberTypeSelect.dataset.selectedValue = ''
    memberTypeSelect.dispatchEvent(new Event('change'))
  }

  countrySelect.addEventListener('change', updateMemberTypeOptions)
  updateMemberTypeOptions()
}

// Registration industry categories
const initIndustryCategories = () => {
  const memberTypeSelect = document.getElementById('user_member_type_id')
  const industryCategorySelect = document.getElementById('user_industry_category_id')

  if (!memberTypeSelect || !industryCategorySelect) return

  const categoriesByMemberType = JSON.parse(
    industryCategorySelect.dataset.industryCategories || '{}'
  )

  const updateIndustryCategoryOptions = () => {
    const memberTypeId = memberTypeSelect.value
    const desiredValue =
      industryCategorySelect.dataset.selectedValue || industryCategorySelect.value
    const categories = categoriesByMemberType[memberTypeId] || []

    industryCategorySelect.innerHTML = '<option value="">Please Select</option>'

    categories.forEach(({ id, name }) => {
      const option = document.createElement('option')
      option.value = id
      option.textContent = name
      industryCategorySelect.appendChild(option)
    })

    if (categories.some(({ id }) => String(id) === String(desiredValue))) {
      industryCategorySelect.value = desiredValue
    } else {
      industryCategorySelect.value = ''
    }

    industryCategorySelect.disabled = categories.length === 0
    industryCategorySelect.required = categories.length > 0
    industryCategorySelect.dataset.selectedValue = ''
    industryCategorySelect.dispatchEvent(new Event('change'))
  }

  memberTypeSelect.addEventListener('change', updateIndustryCategoryOptions)
  updateIndustryCategoryOptions()
}

const initMemberTypeUploadRequirement = () => {
  const memberTypeSelect = document.getElementById('user_member_type_id')
  const memberTypeUploadInput = document.getElementById('user_member_type_upload')
  const memberTypeUploadButton = document.querySelector('label[data-upload-button]')

  if (!memberTypeSelect || !memberTypeUploadInput) return

  const exemptNames = JSON.parse(memberTypeUploadInput.dataset.exemptNames || '[]')

  if (memberTypeUploadButton) {
    memberTypeUploadButton.addEventListener('click', (e) => {
      if (memberTypeUploadButton.dataset.disabled === 'true') e.preventDefault()
    })
  }

  const updateUploadRequirement = () => {
    const selectedOption = memberTypeSelect.options[memberTypeSelect.selectedIndex]
    const selectedName = selectedOption?.text?.trim() || ''
    const required = selectedName.length > 0 && !exemptNames.includes(selectedName)

    memberTypeUploadInput.required = required
    memberTypeUploadInput.disabled = !required

    if (memberTypeUploadButton) {
      memberTypeUploadButton.dataset.disabled = String(!required)
    }
  }

  memberTypeSelect.addEventListener('change', updateUploadRequirement)
  updateUploadRequirement()
}

// Initialize all custom functionality
const initRegistration = () => {
  initMemberTypes()
  initIndustryCategories()
  initMemberTypeUploadRequirement()
}

export default initRegistration
